<template>
    <div v-bind:class="{ condensed: condensed }">
        <b-form-group label="Question" label-for="question">
            <TipTap
                v-model="editable_content.question"
                :class="{'is-invalid': validating && !editable_content.question}"
                :menu_items="['bold', 'italic', 'underline', 'bullet_list', 'ordered_list', 'image', 'edit_html']"
            />

            <b-form-invalid-feedback :state="validating && !editable_content.question ? false : null">
                Question is required
            </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Options" label-for="options">
            <div v-for="(answer, index) in editable_content.possible_answers" :key="answer.id" class="mb-1">
                <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                        <b-input-group>
                            <b-input-group-prepend is-text class="text-uppercase">
                                <div class='answer-option'>{{answer.option}}</div>
                            </b-input-group-prepend>

                            <b-input-group-prepend is-text>
                                <b-form-radio
                                    v-model="editable_content.answer"
                                    :value="answer.option"
                                    :disabled="!answer.value"
                                    :state="validating && !editable_content.answer ? false : null"
                                    class="mr-n2"
                                >
                                    <span class="sr-only"></span>
                                </b-form-radio>
                            </b-input-group-prepend>

                            <TipTap
                                v-if="!condensed"
                                v-model="answer.value"
                                :class="{'is-invalid': validating && !answer.value, 'form-control': true}"
                                :menu_type="'wysiwyg_menu_type'"
                                :hide_word_count="true"
                                :show_related_media_modal="answer.show_add_related_media_modal"
                                @closeSbpModal="answer.show_add_related_media_modal = false"
                            />

                            <b-input-group-append>
                                <b-btn variant="info" content="Add SBP Image" v-tippy="{placement: 'top'}" @click="answer.show_add_related_media_modal = true">
                                    SBP
                                </b-btn>
                            </b-input-group-append>

                            <b-form-input v-if="condensed" v-model="answer.value" :state="validating && (!answer.value) ? false : null"/>

                        </b-input-group>
                    </div>
                    <div v-if="can_edit_option_count && editable_content.possible_answers && editable_content.possible_answers.length && (index > 1)" class="ml-2">
                        <b-btn variant="link" class="text-danger" @click.prevent="removeOption(index)">
                            <font-awesome-icon :icon="['far', 'times']" />
                        </b-btn>
                    </div>
                </div>

                <b-form-invalid-feedback :state="validating && (!answer.value) ? false : null">
                    Option text is required
                </b-form-invalid-feedback>
            </div>

            <b-form-invalid-feedback :state="validating && editable_content.answer == null ? false : null">
                Answer is required
            </b-form-invalid-feedback>
        </b-form-group>

        <div class="mb-3">
            <b-btn v-if="can_edit_option_count" size="sm" variant="outline-primary" @click.prevent="addOption">
                <font-awesome-icon :icon="['fad', 'plus-square']" /> Add Option
            </b-btn>
        </div>
    </div>
</template>

<style scoped>
.answer-option {
    min-width: 15px;
}
.form-control {
    height: auto;
}
.form-control >>> .editor-content {
    border: none;
}
.form-control >>> .ProseMirror {
    padding: 0;
    min-height: 60px;
}
</style>

<script>
import { mapState } from 'vuex'

export default {
    data: () => ({
        editable_content: {
            question: '',
            possible_answers: [
                {
                    id: Math.floor(Math.random() * 1000000),
                    option: 'a',
                    show_add_related_media_modal: false,
                    value: ''
                },
                {
                    id: Math.floor(Math.random() * 1000000),
                    option: 'b',
                    show_add_related_media_modal: false,
                    value: ''
                },
                {
                    id: Math.floor(Math.random() * 1000000),
                    option: 'c',
                    show_add_related_media_modal: false,
                    value: ''
                },
                {
                    id: Math.floor(Math.random() * 1000000),
                    option: 'd',
                    show_add_related_media_modal: false,
                    value: ''
                }
            ],
            answer: ''
        },
        letters: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k']
    }),
    props: {
        'question': Object,
        'condensed': Boolean,
        'article': {
            type: Object,
            default: null
        }
    },
    components: {
        TipTap: () => import('@/components/tiptap/TipTap')
    },
    computed: {
        ...mapState({
            validating: state => state.utilities.validating
        }),
        can_edit_option_count() {
            return !this.article || this.article.is_activity || this.article.is_assessment
        }
    },
    watch: {
        editable_content: {
            handler(editable_content) {
                if (editable_content) {
                    this.$set(this.question, 'content', editable_content)
                }
            },
            deep: true
        }
    },
    methods: {
        addOption() {
            let length = this.editable_content.possible_answers.length
            this.editable_content.possible_answers.push({
                id: Math.floor(Math.random() * 1000000),
                option: this.letters[length],
                show_add_related_media_modal: false,
                value: ''
            })
        },
        removeOption(index) {
            this.editable_content.answer = ''
            this.editable_content.possible_answers.splice(index, 1)
            _.each(this.editable_content.possible_answers, (answer, index) => {
                answer.option = this.letters[index]
            })
        }
    },
    created() {
        if (this.question && this.question.content) {
            let q = _.cloneDeep(this.question)
            this.$set(this.editable_content, 'possible_answers', q.content.possible_answers)
            this.$set(this.editable_content, 'answer', q.content.answer)
            this.$set(this.editable_content, 'question', q.content.question)
            _.each(this.editable_content.possible_answers, answer => {
                this.$set(answer, 'id', Math.floor(Math.random() * 1000000))
                this.$set(answer, 'show_add_related_media_modal', false)
            })
        }
    }
}
</script>
